var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\r\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451 5104 c-199 -53 -384 -239 -436 -440 -19 -75 -20 -242 0 -317 85 -328 424 -530 749 -447 219 56 394 230 450 447 20 77 21 240 1 313 -56 211 -234 391 -441 444 -77 20 -249 20 -323 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3676 3499 c-337 -44 -632 -223 -805 -489 l-36 -55 -3 233 -2 232 -510 0 -510 0 0 -1710 0 -1710 535 0 535 0 0 941 c0 1020 2 1059 55 1228 83 260 272 391 564 391 176 0 278 -36 374 -132 70 -69 120 -169 150 -302 21 -89 21 -119 24 -1108 l4 -1018 535 0 535 0 -4 1148 c-3 994 -5 1161 -19 1252 -26 164 -47 257 -83 367 -151 455 -451 681 -974 733 -120 12 -267 11 -365 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 1710 l0 -1710 535 0 535 0 0 1710 0 1710 -535 0 -535 0 0 -1710z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c06fa80573aca56710d349c95ed4e0c8.svg";
export { ForwardRef as ReactComponent };